import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedBenefit: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedBenefit(state, payload) {
      state.selectedBenefit = payload
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/featuredListings/featuredEntriesBenefits");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByFindEntryID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/findEntries/featuredListings/featuredEntriesBenefits/byFindEntryID", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/findEntries/featuredListings/featuredEntriesBenefits", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllByFindEntryID", payload.findEntries_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`solutions/findEntries/featuredListings/featuredEntriesBenefits`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllByFindEntryID", payload.findEntries_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedBenefit(state) {
      return state.selectedBenefit
    }
  }
}
